import Api from 'fou-api'
import ProfileDef from 'fou-api/definitions/UserProfile'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import { UserDisplayName } from 'src/utils/helper/user'
import Misc, { getSessionFoundryAiConsentFromLS } from 'src/utils/helper/misc'
import { CONSOLIDATED } from 'src/utils/constants/contract-termination'

export default {
  namespaced: true,

  state() {
    return {
      profile: {},
      processing: false,
      foundries: [],
      defaultFoundry: null,
      sessionFoundryName: '',
      sessionFoundryId: '',
      hasMTFAccess: false,
      userslist: [],
      authroles: [],
      updating: false,
      user: {},
      loadingUser: false,
      removesuccess: false,
      updatesuccess: false,
      userNotFound: false,
      adduser: false,
      returnUrl: '',
      foundryAgreementPermission: '',
      usersLoading: false,
      bannerURL: '',
      logoURL: '',
      sessionFoundryAiConsent: false,
      showReReleaseModal: false
    }
  },

  getters: {
    profile: state => {
      state.profile.displayName = UserDisplayName.get(state.profile.displayName)
      return ProfileDef.build(state.profile)
    },
    foundries: state => {
      return state.foundries
    },
    defaultFoundry: state => {
      return state.defaultFoundry
    },
    sessionFoundryName: state => {
      return state.sessionFoundryName
    },
    sessionFoundryId: state => {
      return state.sessionFoundryId
    },
    loadingFoundrySpinner: state => {
      return state.processing
    },
    usersList: state => {
      return state.userslist
    },
    authRoles: state => {
      return state.authroles
    },
    updateSuccess: state => {
      return state.updatesuccess
    },
    removeSuccess: state => {
      return state.removesuccess
    },
    loadingUpdateSpinner: state => {
      return state.updating
    },
    user: state => {
      return state.user
    },
    loadingUserSpinner: state => {
      return state.loadingUser
    },
    userNotFound: state => {
      return state.userNotFound
    },
    addUserSpinner: state => {
      return state.adduser
    },
    getReturnUrl: state => {
      return state.returnUrl
    },
    getfoundryAgreementPermission: state => {
      return state.foundryAgreementPermission
    },
    getUsersLoader: state => {
      return state.usersLoading
    },
    getFoundryModal: state => {
      return state.isFoundryModal
    },
    getBannerURL: state => {
      return state.bannerURL
    },
    getLogoURL: state => {
      return state.logoURL
    },
    getFoundryAiConsent(state, value = null) {
      return state.sessionFoundryAiConsent;
    },
    showReReleaseModal: state => state.showReReleaseModal,
  },

  mutations: {
    set(state, profile = {}) {
      state.profile = profile
    },
    setFoundries(state, foundriesDetail = {}) {
      state.profile = state.profile || {}
      if (foundriesDetail && foundriesDetail.foundries.length > 0) {
        const foundries = []
        let defaultFoundryId = -1
        if (foundriesDetail.defaultFoundry.hasOwnProperty('id')) {
          defaultFoundryId = foundriesDetail.defaultFoundry.id
        }
        for (const foundry of foundriesDetail.foundries) {
          foundry.default = (foundry.id === defaultFoundryId || false)
          foundries.push(foundry)
        }
        state.foundries = foundries
        state.defaultFoundry = foundriesDetail.defaultFoundry
      }
    },
    updateDefaultFoundry(state, defaultFoundry = {}) {
      if (Object.keys(defaultFoundry).length > 0 && defaultFoundry.hasOwnProperty('id')) {
        for (const foundry of state.foundries) {
          foundry.default = (foundry.id === defaultFoundry.id || false)
        }
      }
    },
    setDefaultFoundry(state, defaultFoundry = {}) {
      state.defaultFoundry = {
        ...defaultFoundry,
        value: defaultFoundry.id,
        label: defaultFoundry.name
      }
    },
    getFoundriesStart(state) {
      state.processing = true
    },
    getFoundriesComplete(state) {
      state.processing = false
    },
    setFoundrySessionName(state, defaultFoundry = {}) {
      state.sessionFoundryName = window.localStorage.getItem('sessionFoundryName') !== null
        ? window.localStorage.getItem('sessionFoundryName')
        : defaultFoundry.name

      setTimeout(() => {
        const foundry = state.foundries.find(f => f.id === state.sessionFoundryId) || defaultFoundry;
        state.hasMTFAccess = foundry ? foundry.hasMTFAccess : false;
        window.localStorage.setItem('hasMTFAccess', state.hasMTFAccess)
      }, (0));
     
      window.localStorage.setItem('sessionFoundryName', state.sessionFoundryName)
    },
    setFoundrySessionId(state, defaultFoundry = {}) {
      state.sessionFoundryId = window.localStorage.getItem('sessionFoundryId') !== null
        ? window.localStorage.getItem('sessionFoundryId')
        : defaultFoundry.id
      window.localStorage.setItem('sessionFoundryId', state.sessionFoundryId)
    },
    setFoundryAiConsent(state, value = false) {
      state.sessionFoundryAiConsent = value;
    },
    clearFoundryData(state) {
      state.foundries = []
      state.defaultFoundry = null
      state.sessionFoundryName = ''
      state.sessionFoundryId = ''
      state.bannerURL = ''
      state.logoURL = ''
    },
    setUsersList(state, users) {
      let currentUser = window.localStorage.getItem('current_user')
      let loggedInUser = users.find(user => user.email === currentUser)
      users = users.filter(user => user.email !== currentUser)
      users = users.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      if (JSON.parse(window.localStorage.getItem('FS-Impersonate'))) {
        state.userslist = [...users]
      } else {
        state.userslist = [loggedInUser, ...users]
      }
    },
    setAuthRoles(state, roles) {
      state.authroles = roles
    },
    updateUsersList(state, userId) {
      state.userslist = state.userslist.filter(user => user.userId !== userId)
    },
    updateStart(state) {
      state.updating = true
    },
    updateComplete(state) {
      state.updating = false
    },
    setUser(state, user) {
      state.user = user
    },
    clearSearchedUser(state) {
      state.user = {}
    },
    loadingStart(state) {
      state.loadingUser = true
    },
    loadingStop(state) {
      state.loadingUser = false
    },
    setUpdateSuccess(state, flag) {
      state.updatesuccess = flag
    },
    setRemoveSuccessTrue(state, flag) {
      state.removesuccess = flag
    },
    setRemoveSuccessFalse(state, flag) {
      state.removesuccess = flag
    },
    userNotFoundError(state) {
      state.userNotFound = true
    },
    userNotFoundErrorRemove(state) {
      state.userNotFound = false
    },
    addUsertoUsersList(state, userdata, email) {
      let user1 = { ...userdata, email }
      state.userslist.push(user1)
    },
    addloadingStart(state) {
      state.adduser = true
    },
    addloadingStop(state) {
      state.adduser = false
    },
    clearUser(state) {
      state.user = {}
    },
    setReturnUrl(state, url) {
      state.returnUrl = url
    },
    setAgreementFoundryPermission(state, value) {
      state.foundryAgreementPermission = value
    },
    usersLoader(state, value) {
      state.usersLoading = value
    },
    setFoundryModal(state) {
      state.isFoundryModal = true
    },
    setBannerURL(state, url) {
      state.bannerURL = url
    },
    setLogoURL(state, url) {
      state.logoURL = url
    },
    updateFoundryReleasedCount (state, { foundryId, count }) {
      const foundry = state.foundries.find(f => f.id === foundryId)
      if (foundry) {
        foundry.previouslyReleasedFamiliesCount = count
      }
    },
    setReReleaseModal (state, show) {
      state.showReReleaseModal = show
    }
  },

  actions: {
    get({ commit }) {
      return new Promise((resolve, reject) => {
        Api.Profile.getProfile()
          .then((response) => {
            localStorage.setItem('current_user', response.data.email)
            localStorage.setItem('display_name', response.data.displayName)
            commit('set', response.data)
            resolve(response)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    update({ commit }, profile = {}) {
      return new Promise((resolve, reject) => {
        Api.Profile.updateProfile(profile)
          .then((response) => {
            if (response.data.success === true) {
              // update display name in local storage (for navigation bar)
              window.localStorage.setItem('display_name', response.data.profile.displayName || '')
              commit('set', response.data.profile)
              resolve(response)
            }
            if (response.data.success === false) {
              reject(Errors.create())
            }
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    addUserPermissions({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('addloadingStart')
        Api.UserManagement.addUserWithPermissionsToFoundry(user.foundryId, { permissionIds: user.permissionIds, auth0UserId: user.auth0UserId, email: user.email, name: user.name })
          .then((response) => {
            if (response.data) {
              commit('addloadingStop')
              commit('clearUser')
              // commit('addUsertoUsersList', response.data, user.email)
              return resolve(response.data)
            }
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            commit('addloadingStop')
            reject(err)
          })
      })
    },
    searchUser({ commit }, userEmail) {
      return new Promise((resolve, reject) => {
        commit('loadingStart')
        Api.UserManagement.searchUserByEmail(userEmail)
          .then((response) => {
            if (response.data) {
              commit('loadingStop')
              commit('setUser', response.data)
              return resolve(response.data)
            }
          })
          .catch((error) => {
            let err = Errors.create(error)
            // commit('errors/add', err)
            commit('userNotFoundError')
            commit('loadingStop')
            reject(err)
          })
      })
    },
    removeUser({ commit }, userObj) {
      commit('updateUsersList', userObj.userId)
      return new Promise((resolve, reject) => {
        Api.UserManagement.deleteUserFromFoundry(userObj.foundryId, userObj.userId)
          .then((response) => {
            window.localStorage.setItem('deletedUserEmail', userObj.email)
            return resolve(response.data)
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    updateUserPermissions({ commit }, dataObj) {
      return new Promise((resolve, reject) => {
        commit('updateStart')
        Api.UserManagement.updateFoundriesUserPermissions(dataObj.foundryId, dataObj.userId, { permissionIds: dataObj.permissionIds })
          .then((response) => {
            if (response.data) {
              commit('updateComplete')
              return resolve(response.data)
            }
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            commit('updateComplete')
            reject(err)
          })
      })
    },
    getRolesFromAuth({ commit }) {
      return new Promise((resolve, reject) => {
        Api.UserManagement.getRoles()
          .then((response) => {
            if (response.data) {
              commit('setAuthRoles', response.data.roles)
              return resolve(response.data.roles)
            }
            return resolve(response)
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getUsersAsPerFoundryDropDown({ commit }, defaultFoundryId) {
      let foundryId = ''
      if (typeof defaultFoundryId === 'object') {
        foundryId = defaultFoundryId.foundryId
      } else {
        foundryId = defaultFoundryId
        commit('usersLoader', true)
      }
      return new Promise((resolve, reject) => {
        Api.UserManagement.allFoundryUser(foundryId)
          .then((response) => {
            if (response.data) {
              commit('setUsersList', response.data.members)
              commit('usersLoader', false)
              return resolve(response.data.members)
            }
            return resolve(response)
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('usersLoader', false)
            commit('errors/add', err)
            reject(err)
          })
      })
    },

    getFoundries({ commit, state }, from) {
      commit('getFoundriesStart')
      return new Promise((resolve, reject) => {
        Api.Users.getUserFoundries()
          .then((response) => {
            if (response.data) {
              let foundries = response?.data?.foundries || []
              window.localStorage.setItem('userFoundries', JSON.stringify(foundries))

              const ctIsUserAdmin = response.data.isUserAdmin || CONSOLIDATED.NONE
              const ctFoundriesTerminated = response.data.foundriesTerminated || CONSOLIDATED.NONE
              window.localStorage.setItem('isUserAdmin', ctIsUserAdmin)
              window.localStorage.setItem('foundriesTerminated', ctFoundriesTerminated)
              commit('auth/setContractTerminationMeta', { isUserAdmin: ctIsUserAdmin, foundriesTerminated: ctFoundriesTerminated }, { root: true })

              commit('setFoundries', response.data)
              commit('setDefaultFoundry', response.data.defaultFoundry || {})
              commit('getFoundriesComplete')
              commit('setFoundrySessionName', response.data.defaultFoundry)
              commit('setFoundrySessionId', response.data.defaultFoundry)
              const sessionFoundryId = window.localStorage.getItem('sessionFoundryId') || '';
              const sessionFoundry = foundries.find(f => f.id === sessionFoundryId) || {};
              commit('setBannerURL', sessionFoundry.bannerUrl)
              commit('setLogoURL', sessionFoundry.logoUrl)
              // Delay the update to ensure localStorage changes are fully committed
              // A setTimeout with 100ms gives plenty of buffer in case the previous setItem was called at the end of the current tick
              // As we will be reading from LS in common function getSessionFoundryAiConsentFromLS
              setTimeout(() => {
                commit('setFoundryAiConsent', getSessionFoundryAiConsentFromLS())
              }, 100)
              //Set UFDA if session Foundry is set
              //This if is just moved down in code.
              if (window.localStorage.getItem('sessionFoundryId') != null) {
                Misc.setDataLayerObj()
              }
              return resolve(response.data)
            }
            return resolve(response)
          })
          .catch((error) => {
            commit('getFoundriesComplete')
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    setDefaultfoundry({ commit }, defaultFoundry = {}) {
      return new Promise((resolve, reject) => {
        if (Object.keys(defaultFoundry).length > 0) {
          Api.Users.setDefaultFoundryForUser(defaultFoundry)
            .then((response) => {
              if (response.data.success === false) {
                return reject(Errors.create())
              }
              commit('setDefaultFoundry', defaultFoundry)
              commit('updateDefaultFoundry', defaultFoundry)
              return resolve(response)
            })
            .catch((error) => {
              const err = Errors.create(error)
              commit('errors/add', err)
              return reject(err)
            })
          return resolve()
        }
        return reject(new Error('default foundry cannot be left blank'))
      })
    },
    changePassword({ commit }, email) {
      return new Promise((resolve, reject) => {
        Api.ChangePassword.changePassword(email)
          .then((response) => {
            return resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            return reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
